<template>
  <div class="tour-step__body">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'MTourBody'
  };
</script>
